export enum AppUrlEnum {
  ArFees = '/legal/ar/fees',
  ArWithdrawalCancellation = '/legal/ar/withdrawal-cancellation',
  CoverageDetail = '/coverage-detail',
  Legal = '/legal',
}

export const AppEnum = {
  StageEnv: process.env.REACT_APP_STAGE || '',
  calendlyUrl: process.env.REACT_APP_CALENDLY_URL || '',
  emailPublicKey: process.env.REACT_APP_EMAIL_PUBLIC_KEY || '',
  emailServiceId: process.env.REACT_APP_EMAIL_SERVICE_ID || '',
  emailTemplateId: process.env.REACT_APP_EMAIL_TEMPLATE_ID || '',
};

export enum AppStage {
  DEV = 'DEV',
  PROD = 'PROD',
  STAGE = 'STAGE',
}

export enum AppCountryCodeEnum {
  AR = 'ar',
  BR = 'br',
  CO = 'co',
  MX = 'mx',
}
